import React, { Fragment, useState } from 'react';
import { Button, Col, Form, Row } from 'reactstrap';
import _ from 'lodash';

import { stopEvent } from '../base/utils/miscutils';

import C from '../C';
import DataStore, { getDataPath } from '../base/plumbing/DataStore';
import ActionMan from '../plumbing/ActionMan';
import Misc from '../base/components/Misc';
import PropControl from '../base/components/PropControl';
import { createBlank, id2canonical } from '../base/components/ListLoad';
import ShareWidget from '../base/components/ShareWidget';
import { isTester } from '../base/Roles';
import ListItems from './ListItems';
import { getDataItem, setWindowTitle } from '../base/plumbing/Crud';
import ErrAlert from '../base/components/ErrAlert';
import KStatus from '../base/data/KStatus';
import { Card } from '../base/components/CardAccordion';
import SavePublishDeleteEtc from '../base/components/SavePublishDeleteEtc';
import Login from '../base/youagain';
import { getType } from '../base/data/DataClass';
import Icon from '../base/components/Icon';
import { getShareListPV, shareThingId } from '../base/Shares';
import XId from '../base/data/XId';
import { A } from '../base/plumbing/glrouter';


function UserPage() {
	const type = C.TYPES.User;

	const path = DataStore.getValue(['location', 'path']);
	const userId = path[1];

	// Admin only: No ID given --> List and create users
	let [error, setError] = useState();
	if (!userId) {
		setWindowTitle(type);
		if (!isTester()) return <ErrAlert error="For authorised admin staff." />;

		let email = DataStore.getValue('widget', 'createUser', 'email');
		let password = DataStore.getValue('widget', 'createUser', 'password');
		const doCreate = e => {
			stopEvent(e);
			// register
			email = email.toLowerCase();
			Login.registerStranger({email, password})
			.then(success => {
				console.log(success, success.responseText, success.statusText);
				createBlank({type, id: `${email}@email`, toCanonical: false});
			}, setError);
		};

		return <>
			<h1>Users</h1>
			<p>
				This page is part of setting up an Agency or Brand user for Green Media.
				The process is a little complex for now. You should:<br/><br/>

				2. Enter their email here to register their login and create a User object here.<br/>
				3. Set the Agency or Advertiser here.<br/>
				4. Share the Agency / Advertiser with their email (a share button will be shown below)
			</p>
			<Form inline onSubmit={doCreate} className="mb-4">
				<PropControl type="email" label="Email" prop="email" path={['widget', 'createUser']} />
				<PropControl type="text" label="Initial Password" prop="password" path={['widget', 'createUser']} />
				<Button className="ml-1 btn-create" type="submit">Create</Button>
				<ErrAlert error={error} />
			</Form>
			<ListItems type={type} canCreate={false} canDelete={false} />
		</>;
	} // no userId

	const item = ActionMan.getDataItem({type, id:userId, status:C.KStatus.DRAFT}).value;
	setWindowTitle(item || type);

	return <div>
		<h1>Edit User: {(item && item.name) || userId}</h1>
		{item ? (
			<EditUserForm item={item} />
		) : (
			<Misc.Loading />
		)}
	</div>;
} // ./UserPage


function EditUserForm({item}) {
	const type = C.TYPES.User;
	const path = getDataPath({status: KStatus.DRAFT, type, id: item.id});

	const pvAgency = item.agencyId && getDataItem({type: C.TYPES.Agency, id: item.agencyId, status: KStatus.PUB_OR_DRAFT, swallow: true});
	const pvBrand = item.vertiser && getDataItem({type: C.TYPES.Advertiser, id: item.vertiser, status: KStatus.PUB_OR_DRAFT, swallow: true});

	return <>
		<Card title="User Setup">
			<div>ID: <A href={item.id} target="_blank">{item.id}</A></div>
			<PropControl label="Name" item={item} path={path} prop="name" />
			<Row>
				<Col sm="6">
					<PropControl label="Agency" path={path} prop="agencyId" type="DataItem" itemType={C.TYPES.Agency} />
					{pvAgency?.value && <ShareControl item={pvAgency.value} uxid={item.id} />}
				</Col>
				<Col sm="6">
					<PropControl label="Brand" path={path} prop="vertiser" type="DataItem" itemType={C.TYPES.Advertiser} />
					{pvBrand?.value && <ShareControl item={pvBrand.value} uxid={item.id} />}
				</Col>
			</Row>
		</Card>
		<SavePublishDeleteEtc type={type} id={item.id} sendDiff cannotDelete noPublish />
	</>;
}


function ShareControl({item, uxid}) {
	let type = getType(item);
	const shareId = shareThingId(type, item.id);
	let pvShares = getShareListPV(shareId);
	let canReadItem = false;
	if (pvShares.value) {
		console.warn(pvShares.value);
		let sharesToUser = pvShares.value.filter(s => (s._to === uxid || id2canonical(s._to) == uxid));
		if (sharesToUser.length) canReadItem = true;
	}
	uxid = XId.isa(uxid) ? XId.id(uxid) : uxid;
	return <>
		<ShareWidget item={item} email={XId.isa(uxid) ? uxid : ''} hasButton>Share this {type}</ShareWidget>
		{!pvShares.resolved ? '...' : (
			canReadItem ? (
				<Icon title={`Shared with user ${uxid}`} name="tick" color="success"/>
			) : (
				<span className="text-danger" title={`Not shared with user ${uxid}`} >X</span>
			)
		)}
		</>;
}

export default UserPage;
